import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './indicator-data.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const IndicatorDataDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const indicatorDataEntity = useAppSelector(state => state.indicatorData.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="indicatorDataDetailsHeading">
          <Translate contentKey="fleetSenseApp.indicatorData.detail.title">IndicatorData</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{indicatorDataEntity.id}</dd>
          <dt>
            <span id="created">
              <Translate contentKey="fleetSenseApp.indicatorData.created">Created</Translate>
            </span>
          </dt>
          <dd>{indicatorDataEntity.created ? <TextFormat value={indicatorDataEntity.created} type="date" format={APP_DATE_FORMAT} /> : null}</dd>
          <dt>
            <span id="value">
              <Translate contentKey="fleetSenseApp.indicatorData.value">Value</Translate>
            </span>
          </dt>
          <dd>{indicatorDataEntity.value}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.indicatorData.truckImplement">Truck Implement</Translate>
          </dt>
          <dd>{indicatorDataEntity.truckImplement ? indicatorDataEntity.truckImplement.licensePlate : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.indicatorData.company">Company</Translate>
          </dt>
          <dd>{indicatorDataEntity.company ? indicatorDataEntity.company.name : ''}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.indicatorData.indicator">Indicator</Translate>
          </dt>
          <dd>{indicatorDataEntity.indicator ? indicatorDataEntity.indicator.name : ''}</dd>
        </dl>
        <Button tag={Link} to="/indicator-data" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/indicator-data/${indicatorDataEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default IndicatorDataDetail;
